import React from 'react';

import CountryProfileSubSectionAnswer from './CountryProfileSubSectionAnswer';
import CountryProfileSubSectionCheckboxList from './CountryProfileSubSectionCheckboxList';
import CountryProfileSubSectionTable from './CountryProfileSubSectionTable';

class CountryProfileSubSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      answers: this.formatAnswers(props.data)
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data !== this.props.data) {
      this.setState({
        answers: this.formatAnswers(nextProps.data)
      });
    }
  }

  formatAnswers(data) {
    // Guard against null or undefined data
    if (!data || !Array.isArray(data)) {
      console.error('Invalid data passed to formatAnswers:', data);
      return [];
    }

    const formattedData = [];
    let checkboxList = [];
    let hasInitialCheckboxes = false;

    // First pass - check if we start with checkboxes
    for (let i = 0; i < data.length; i++) {
      const item = data[i];
      if (item.checkbox) {
        hasInitialCheckboxes = true;
        break;
      } else if (item.answer || item.text) {
        break;
      }
    }

    // If we start with checkboxes, create a dummy container item first
    if (hasInitialCheckboxes) {
      formattedData.push({
        answer: '',
        text: '',
        // This will be replaced by the list of initial checkboxes
      });
    }

    // Process all items
    data.forEach((item) => {
      if (item.checkbox) {
        checkboxList.push(item.answer);
      } else if (item.answer || item.text) {
        if (checkboxList.length > 0 && formattedData.length > 0) {
          // Safely add the checkbox list to the previous item
          formattedData[formattedData.length - 1].list = checkboxList.slice(0);
          checkboxList.length = 0;
        }
        formattedData.push(item);
      }
    });

    // Handle any remaining checkboxes at the end
    if (checkboxList.length > 0 && formattedData.length > 0) {
      formattedData[formattedData.length - 1].list = checkboxList.slice(0);
    }

    console.log('Formatted answers:', formattedData);
    return formattedData;
  }

  renderAnswers() {
    const answers = this.state.answers;

    return answers.map((item, index) => {
      let Component,
        className,
        content;

      if (Array.isArray(item.answer)) {
        Component = CountryProfileSubSectionTable;
      } else if (item.answer) {
        Component = CountryProfileSubSectionAnswer;
      } else if (item.text) {
        Component = CountryProfileSubSectionCheckboxList;
      }

      if (item.display !== 'CP-heading') {
        className = 'expandlater';
      }

      if (item.question && item.answer && !Array.isArray(item.answer)) {
        content = `${item.question} ${item.answer}`;
      } else {
        content = item.answer || item.text;
      }

      if (!Component) return null;

      return (
        <Component
          key={ index }
          content={ content }
          list={ item.list }
          className={ className }
        />
      );
    });
  };

  renderTitle() {
    const answers = this.state.answers
    if (answers.length > 0 && answers[0].display !== 'CP-heading'){
        return (<strong className="subtitle expandlater">{ this.props.name }</strong>);
        }
     return (<strong className="subtitle">{ this.props.name }</strong>);
  }

  render() {
    return (
      <div>
        {this.renderTitle()}
        <div className="country-profile__subsection-answers">
          { this.renderAnswers() }
        </div>
      </div>
    );
  }
}

export default CountryProfileSubSection;



// WEBPACK FOOTER //
// ./src/components/CountryProfile/CountryProfileSubSection.js